// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"25825":"32f24d46d49c4c3156ff","45244":"96445e3f0171e33a3241","80020":"ea7198838d3ea5473132"}[chunkId] + ".css";
};